import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { IChangeHistoryState } from "./changeHistory.types";
import { fetchChangeHistoryAsync } from "./changeHistoryThunk";

const initialState: IChangeHistoryState = {
  list: [],
  loading: LoadState.NotLoaded,
  error: null,
};

const changeHistorySlice = createSlice({
  name: "changeHistory",
  initialState,
  reducers: {
    clearChangeHistoryState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchChangeHistoryAsync.pending, (state) => {
      state.loading = LoadState.InProgress;
      state.error = null;
    });
    builder.addCase(fetchChangeHistoryAsync.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = LoadState.Loaded;
    });
    builder.addCase(fetchChangeHistoryAsync.rejected, (state, action) => {
      state.loading = LoadState.Failed;
      state.error =
        action.payload?.message || "Failed to fetch change history";
    });
  },
});

export const { clearChangeHistoryState } = changeHistorySlice.actions;
export const changeHistoryReducer = changeHistorySlice.reducer;
